const confettiConfig = {
    elementCount: 64,
    spread: 160,
    duration: 2400,
    stagger: 6,
    width: "10px",
    height: "10px"
};

export default confettiConfig;
